import whiteLogo from '@/shared/assets/gif/white_logo.gif';

interface RouteLoaderProps {
  isVisible?: boolean;
}

export const RouteLoader = ({ isVisible = true }: RouteLoaderProps) => {
  return (
    <div
      className={`
    fixed top-0 left-0
    w-full h-full
    bg-[#121212]
    flex items-center justify-center
    z-9999
    transition-opacity duration-1000 ease-out
    ${isVisible ? 'opacity-100' : 'opacity-0'}
  `}
    >
      <img
        src={whiteLogo}
        alt="Loading..."
        style={{
          maxWidth: '200px',
          maxHeight: '200px'
        }}
      />
    </div>
  );
};
